import React from 'react';
import { Icon } from './Icon.js';
export const IconProgress = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 2V12H22", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C8.72836 2 5.82368 3.57111 3.99927 6H3L2 3", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconProgress.js.map